import React from 'react';

import { Tr } from '@chakra-ui/react';

import CompositionGroupTable from './CompositionGroupTable';
import { formatCurrency } from './formatters';
import { StyledTd, StyledTh } from './StyledTableCell';

export type EquipmentGroupRow = {
  code: string;
  description: string;
  quantity: number;
  usageOperative: number;
  usageIdle: number;
  costOperative: number;
  costIdle: number;
  hourlyCost: number;
};

type EquipmentGroupTableProps = {
  data: EquipmentGroupRow[];
};

const EquipmentGroupTable: React.FC<EquipmentGroupTableProps> = ({ data }) => {
  const totalHourlyCost = data.reduce(
    (total, item) => total + item.hourlyCost,
    0,
  );

  return (
    <CompositionGroupTable
      headerRows={
        <>
          <Tr>
            <StyledTh colSpan={2}>A - EQUIPAMENTOS</StyledTh>
            <StyledTh textAlign="center" width="90px">
              Quantidade
            </StyledTh>
            <StyledTh colSpan={2} textAlign="center">
              Utilização
            </StyledTh>
            <StyledTh colSpan={2} textAlign="center">
              Custo Operacional
            </StyledTh>
            <StyledTh textAlign="center" width="110px">
              Custo Horário
            </StyledTh>
          </Tr>
          <Tr>
            <StyledTh colSpan={2} />
            <StyledTh />
            <StyledTh textAlign="center">Operativa</StyledTh>
            <StyledTh textAlign="center">Improdutiva</StyledTh>
            <StyledTh textAlign="center">Operativa</StyledTh>
            <StyledTh textAlign="center">Improdutiva</StyledTh>
            <StyledTh />
          </Tr>
        </>
      }
      bodyRows={
        <>
          {data.map((item) => (
            <Tr key={item.code}>
              <StyledTd width="1%" minWidth="50px" whiteSpace="nowrap">
                {item.code}
              </StyledTd>
              <StyledTd
                minWidth="220px"
                whiteSpace="normal"
                overflowWrap="break-word"
                wordBreak="break-word"
              >
                {item.description}
              </StyledTd>
              <StyledTd textAlign="center">{item.quantity}</StyledTd>
              <StyledTd textAlign="center" width="90px">
                {item.usageOperative}
              </StyledTd>
              <StyledTd textAlign="center" width="90px">
                {item.usageIdle}
              </StyledTd>
              <StyledTd textAlign="right" width="110px">
                {formatCurrency(item.costOperative)}
              </StyledTd>
              <StyledTd textAlign="right" width="110px">
                {formatCurrency(item.costIdle)}
              </StyledTd>
              <StyledTd textAlign="right" width="110px">
                {formatCurrency(item.hourlyCost)}
              </StyledTd>
            </Tr>
          ))}

          <Tr>
            <StyledTd colSpan={7} textAlign="right" fontWeight="600">
              Custo Horário de Equipamentos
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(totalHourlyCost)}
            </StyledTd>
          </Tr>
        </>
      }
    />
  );
};

export default EquipmentGroupTable;
